import React, { useState,useEffect,useRef,useContext, Children } from "react";
import { Container, Row, Col, Button, Form, Modal, Table, Alert, Badge, Card, Spinner } from 'react-bootstrap';
import Select from 'react-select'
import { number_format, uniqid, getDepartamento } from "./utils";
import "./modals.css"
import { useSelector,useDispatch, } from 'react-redux';
import { setStateGlobal, showAlert } from "../reducers/appReducer";
import moment from "moment";
import { AuthContext } from '../auth/AuthContext';

const ModalNuevaCotizacion = ({ show, handleClose, socket}) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalNuevaCotizacion,
  } = stateGlobal;

  const [clientes,setClientes] = useState([]);
  const [idCliente,setIdCliente] = useState("");

  const options = [
    { value: '1241247128941', label: 'José De Jesús Yañez Mar'},
    { value: '8698698689', label: 'Pablo Morales Ferreira'},
    { value: '120896929', label: 'Julio Cesar Torres'},
  ]

  useEffect( () => {
    getClientes();
  },[])

  const getClientes = () => {
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getNombresClientes',{
      method: 'POST',
      mode: 'cors',
    })
    .then( response => response.json())
    .then( response => {
      setClientes(response.documents)
    })
  }

  // const handleSetSection = (section) => setState({ ...state, section: section });
  // const onContinueCotizacion = () => {
  //   const { id_cotizacion, } = newCotizacion

  //   // Validamos que ya haya elegido una cotización
  //   if(id_cotizacion === '') {
  //     dispatch( showAlert( {
  //       show : true, 
  //       message : 'Por favor, elige un tipo de cotización para continuar',
  //       type: 'error',
  //       duration: 2000,
  //     } ) )
  //     return false
  //   }

  //   // Cerramos el modal y Abrimos el sidebar
  //   dispatch( setStateGlobal({ showModalNuevaCotizacion: false, showSidebarNuevaCotizacion: true, }) )

  // }

  return (
    <Modal show={showModalNuevaCotizacion} onHide={ () => {
      dispatch( setStateGlobal({ showModalNuevaCotizacion: false, }) )
    }} size="lg" fullscreen={false}>
      <Modal.Header closeButton className="ws-modal-header title">
        <Modal.Title>Cotización para:</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <Form>
                  <Form.Group className="mb-3">

                    <Select
                    placeholder="Selecciona un cliente"
                    options={stateHome.arrSelectClientes}
                    onChange={
                      (ev) => {
                        setIdCliente(ev.value)
                      }
                    }
                    />

                    {/* <Form.Select defaultValue={''} onChange={(ev) => setIdCliente(ev.target.value)}>
                      <option selected={''} disabled value="">Selecciona un cliente</option>
                      <option key={`cliente-0`} value={'1241247128941'}>José De Jesús Yañez Mar</option>
                      <option key={`cliente-1`} value={'8698698689'}>Pablo Morales Ferreira</option>
                      <option key={`cliente-2`} value={'120896929'}>Julio Cesar Torres</option>
                    </Form.Select> */}
                  </Form.Group>
                </Form>

                <Button onClick={()=>window.location.href=`directorio?ref=nuevacotizacion`} className="ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary">
                  <i className="bi bi-person-plus-fill"></i>&nbsp;Agregar nuevo cliente
                </Button>

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        {/* <button onClick={() => { onContinueCotizacion() }} className="btn btn-primary ws-btn-blue-2">Continuar</button> */}
        <button onClick={() => window.location.href=`nuevaCotizacion?id=${idCliente}` } className="btn btn-primary ws-btn-blue-2">Continuar</button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalRealizarCobro = ({ show, handleClose, filteredData, socket }) => {

  const { usuario } = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalRealizarCobro,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  //Referencias
  const refSelectFormaPago = useRef(null);
  const refCantidadRecibida = useRef(null);
  const refComprobantePago = useRef(null);
  const refLabelComprobantePago = useRef(null);

  const refNoCheque = useRef(null);
  const refBanco = useRef(null);
  const refReceptor = useRef(null);

  const refReferencia = useRef(null);
  const refCuentaReceptora = useRef(null);
  const refFechaReferencia = useRef(null);

  const [cantidadRecibida, setCantidadRecibida] = useState('')
  const [viewListArr, setViewListArr] = useState([])
  const [fileComprobante,setFileComprobante] = useState([]);
  const [viewmore, setViewmore] = useState(false);
  const [data,setData] = useState({
    isSendData: false,
    isError: false,
    messageError: ''
  })
  const [selectFormaPago,setSelectFormaPago] = useState('Efectivo');
  const [btnIsLoading, setBtnIsLoading] = useState(false);

  const handleViewMore = () =>{
    setViewmore(!viewmore);
  }

  const isPayed = (cantidadRecibida) => {
    const { arrCobranza, cantidad } = dataTramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    // console.log('cantidad - Totalabonos + cantidad recibida',  ( parseFloat(cantidad)  - (totalAbonos + parseFloat(cantidadRecibida)) ) )
    return ( ( parseFloat(cantidad)  - (totalAbonos + parseFloat(cantidadRecibida)) ) <= 0) ? true : false;
  }

  const getItemByArrProcess = (_item, id) => {

    let itemTramite, _tmp = _item
    // Posición 0 en arrOT significa le primer trámite (pensamos en un multitrámites en algún momento)
    const arrProcess = _tmp.arrOT[0].arrProcess

    for(var a in arrProcess) {
      if(arrProcess[a].id === id) {
        itemTramite = arrProcess[a]
      }
    }

    return itemTramite
  }

  const realizaCobro = (opt) => {

    if(selectFormaPago !== 'Efectivo'){
      if(refComprobantePago.current !== null){
        if(refComprobantePago && refComprobantePago.current.value === ''){
          setData( prevState => ({
            ...prevState,
            isError: true,
            messageError: 'Sube un comprobante de pago'
          }))
          refLabelComprobantePago.current.classList.add('label-button-focus');
          return false;
        }
        refLabelComprobantePago.current.classList.remove('label-button-focus');
      }
    }
    
     if(refCantidadRecibida.current.value === ''){
      setData( prevState => ({
        ...prevState,
        isError: true,
        messageError: 'Ingresa la cantidad recibida'
      }))
      refCantidadRecibida.current.focus();
      return false;
    }

    if(opt === 2) {

      /**
       * COBRO MULTIPLE **/
       alert('Módulo inactivo, falta seguimiento de conceptos de pago\n#Removido de git -> 07/06/2023')
       return false
       
    } else {

      let cantidadNumber = 0

      if(dataTramite.cantidad) {
        cantidadNumber = dataTramite.cantidad
      }

      let totalAbonos = 0
      if(dataTramite.arrCobranza) {
        dataTramite.arrCobranza.map((t,e) => {
          totalAbonos += parseFloat(t.cantidadRecibida)
        })
      }
      const total = (cantidadNumber - totalAbonos) - cantidadRecibida

      const formaPago = refSelectFormaPago.current.value;

      const formData = new FormData();
      formData.append('id_cotizacion', dataTramite.id_cotizacion);
      formData.append('cantidadRecibida',cantidadRecibida);
      formData.append('forma_pago',formaPago);
      formData.append('created_at',moment().format('YYYY-MM-DD HH:mm:ss'));
      if(selectFormaPago !== 'Efectivo'){
        fileComprobante.map((t0, e0) => {
          formData.append('files[]', t0)
        })
      }
      if(selectFormaPago==='Cheque'){
        formData.append('no_cheque', refNoCheque.current.value);
        formData.append('banco', refBanco.current.value);
        formData.append('receptor', refReceptor.current.value);
      }
      if(selectFormaPago==='Transferencia interbancaria'){
        formData.append('referencia', refReferencia.current.value);
        formData.append('cuenta_receptora', refCuentaReceptora.current.value);
        formData.append('fecha_referencia', refFechaReferencia.current.value);
      }

      setBtnIsLoading(true);

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveTramiteCobranza',{
       method: 'POST',
       mode: 'cors',
       body: formData,
      })
      .then( response => response.json())
      .then( response => {

        let _dataTramite = [], _tmp = dataTramite
        for(var a in _tmp.arrOT[0].arrProcess) {

          if(_tmp.arrOT[0].arrProcess[a].id === 'caja') {
            _dataTramite.push({
              ..._tmp.arrOT[0].arrProcess[a],
              status: isPayed(refCantidadRecibida.current.value) ? 2 : 1,
            })
          } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {

            /**
             * Aquí definimos si:
             * Trámite está 100% pagado
             * OT está terminado
             * El status de finanzas tiene 0
             * El trámite está con opción de pago contado
            */

            const itemOt = getItemByArrProcess(dataTramite, 'orden_trabajo'),
            itemFinanzas = getItemByArrProcess(dataTramite, 'finanzas')
            // [W] Corregir

            // Separamos si el trámite es contado / crédito

            if( dataTramite.metodo_pago === 'contado' ) {

              if( isPayed(refCantidadRecibida.current.value) &&
                itemOt.status === 2 &&
                itemFinanzas.status === 0) {
                _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 1, })
              } else {
                _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
              }

            } else {
              _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
            }

            /*
            if( isPayed(refCantidadRecibida.current.value) &&
              itemOt.status === 2 &&
              itemFinanzas.status === 0
              ) {
              _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 1, })
            } else if( itemFinanzas.status < 2 ) {
              _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 0, })
            } else {
              _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
            }
            */

          } else {
            _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
          }
        }

        const arrHistory = [...dataTramite.arrOT[0].arrHistory, {
          usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Registró un nuevo cobro", id: 'caja',
        }]

        const dataUpdate = {
          info: dataTramite.arrOT[0].info,
          arrHistory,
          arrProcess: _dataTramite,
          id_tramite_ot: dataTramite.id_cotizacion,
          id_cotizacion: dataTramite.id_cotizacion,
          total,
        }

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
         method: 'POST',
         mode: 'cors',
         body: JSON.stringify(dataUpdate),
        })
        .then( response => response.json())
        .then( response => {

          dispatch( showAlert( {
            show : true, 
            message : 'Pago de trámite realizado con éxito',
            type: 'success',
            duration: 3000,
          } ) )

          setTimeout(() => {
            socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', })
          }, 1500)

        })

      })
    }

  }

  const getHistorialPagos = () => {

    let newArr = []

    for(var a in filteredData) {
        newArr.push({
          ...filteredData[a],
          cantidadRecibida: 0,
        })
    }
    setViewListArr(newArr)
  }

  let cantidadNumber = 0

  if(dataTramite.cantidad) {
    cantidadNumber = dataTramite.cantidad
  }

  const getTotalAbonos = (dataTramite) => {
    let totalAbonos = 0
    if(dataTramite.arrCobranza) {
      dataTramite.arrCobranza.map((t,e) => {
        totalAbonos += parseFloat(t.cantidadRecibida)
      })
    }
    return totalAbonos
  }

  const setUpdateCantidadRecibida = (index, cantidad) => {
    viewListArr[index].cantidadRecibida = parseFloat(cantidad)
    setViewListArr(viewListArr)
  }

  let totalAbonos = 0
  if(dataTramite.arrCobranza) {
    dataTramite.arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
  }

  return (
    <Modal show={showModalRealizarCobro} onHide={ () => {
      dispatch( setStateGlobal({ showModalRealizarCobro: false, }) )
    }} size="xl" fullscreen={false}>
      <Modal.Header closeButton className="ws-modal-header title">
        <Modal.Title>Realizar cobro a: <b style={{fontSize:'1.3rem'}}>{dataTramite.nombre}</b></Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Button className="mb-3 ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary"
        onClick={ () => window.open(`directorio?id=${dataTramite['id_cliente']}`, '_blank').focus() }
        ><i className="bi bi-eye"></i> Ver perfil</Button>
        <Button className="ms-2 mb-3 ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary"
        onClick={handleViewMore}
        ><i className={`bi bi-${(viewmore) ? 'dash' : 'plus'}`}></i> Ver { (viewmore) ? 'menos' : 'mas'}</Button>
        
        <Container className="ws-box-container">
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Form>
                  
                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Cantidad:</b></p>
                    </Col>
                    <Col sm="9">
                      <p>${number_format(dataTramite.cantidad)}</p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Forma de pago:</b></p>
                    </Col>
                    <Col sm="9">
                      <Form.Select ref={refSelectFormaPago} defaultValue={dataTramite.forma_pago}
                      onChange={(e) => setSelectFormaPago(e.target.value)}
                      >
                       <option value="">Elige la forma de pago</option>
                        <option value={'Efectivo'}>Efectivo</option>
                        <option value={'Cheque'}>Cheque</option>
                        <option value={'Transferencia interbancaria'}>Transferencia interbancaria</option>
                        <option value={'Tarjeta de crédito'}>Tarjeta de crédito</option>
                        <option value={'Tarjeta de débito'}>Tarjeta de débito</option>
                      </Form.Select>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Método de pago:</b> </p>
                    </Col>
                    <Col sm="9">
                      <p>{dataTramite.metodo_pago}</p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Cantidad abonada:</b></p>
                    </Col>
                    <Col sm="9">
                      <p>${number_format( totalAbonos )}</p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Cantidad faltante:</b></p>
                    </Col>
                    <Col sm="9">
                      <p>${number_format( (cantidadNumber - totalAbonos) - cantidadRecibida )}</p>
                    </Col>
                  </Form.Group>

                  <hr />

                  {
                    (selectFormaPago === 'Cheque') && (
                      <>
                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>No. Cheque:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control ref={refNoCheque} placeholder="Ingresa el número del cheque" />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>Banco:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control ref={refBanco} placeholder="Ingresa el banco" />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>Receptor:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control ref={refReceptor} placeholder="Ingresa el receptor" />
                        </Col>
                      </Form.Group>
                      </> 
                    )
                  }

                  {
                    (selectFormaPago === 'Transferencia interbancaria') && (
                      <>
                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>Referencia:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control ref={refReferencia} placeholder="Ingresa el número de referencia" />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>Cuenta receptora:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control ref={refCuentaReceptora} placeholder="Ingresa la cuenta receptora" />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-2">  
                        <Col sm="3" className="text-lg-end">
                          <p><b>Fecha de referencia:</b></p>
                        </Col>
                        <Col sm="9">
                          <Form.Control type="date" ref={refFechaReferencia} />
                        </Col>
                      </Form.Group>
                      </> 
                    )
                  }

                  {
                    (selectFormaPago !== 'Efectivo') && (
                      <Form.Group as={Row} className="mb-2">
                        <Col sm="3" className="text-lg-end">
                          <p><b>Subir comprobantes:</b></p>
                        </Col>
                        <Col sm="9">
                          {
                            fileComprobante.length > 0 &&
                              <div>
                              { fileComprobante.map((t, e) => {
                                return (
                                  <Row className="mb-2">
                                    <Col> 
                                      <h6 key={e} className="mb-0">{t.name}&nbsp;</h6>
                                    </Col>
                                    <Col> 
                                      - <Button 
                                      className="ws-btn-blue-2"
                                      onClick={
                                        () => {
                                          let newFileComprobante = [...fileComprobante];
                                          newFileComprobante.splice(e,1);
                                          setFileComprobante(newFileComprobante);
                                          // console.log(newFileComprobante);
                                        }
                                      }
                                      >Quitar</Button>
                                    </Col>
                                  </Row> 
                                )
                              }) }
                              </div>
                          }
                          
                          {
                            fileComprobante.length < 1 && (
                              <Form.Label ref={refLabelComprobantePago} labelfor="fileCobrarComprobante" className="btn btn-primary ws-btn-blue-2 label-button">
                        
                                <h6 className="mb-0"><>Subir comprobantes de pago</>&nbsp;<i className="bi bi-upload"></i></h6>
    
                                <Form.Control ref={refComprobantePago} type="file" multiple={true} name="fileCobrarComprobante" id="fileCobrarComprobante" style={{display:'none'}} onChange={ (file) => {
                                  let array = []
                                  for(var a in file.target.files) {
                                    if(typeof file.target.files[a] === 'object') {
                                      array.push(file.target.files[a])
                                    }
                                    if(a == (file.target.files.length - 1)) {
                                      setFileComprobante(array)
                                    }
                                  }
                                } } />
    
                              </Form.Label>
                            )
                          }
                         
                        </Col>
                      </Form.Group>
                    )
                  }
                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Cantidad recibida:</b></p>
                    </Col>
                    <Col sm="9">
                    <Form.Control ref={refCantidadRecibida} type={'text'} placeholder={'Ingresa la cantidad recibida...'} onChange={(ev) => { setCantidadRecibida(ev.target.value) }} value={cantidadRecibida} />
                    </Col>
                  </Form.Group>

                  {
                    data.isError && <Alert variant="danger"><i className="bi bi-x-octagon-fill"></i>&nbsp;{data.messageError}</Alert>
                  }

                </Form>  
              </div>
            </Col>
          </Row>
        </Container>

        {
          (viewmore) && (
          <Container className="ws-box-container mt-2">
            <Row>
              <Col xs={12} md={6}>
                <Card>
                  <Card.Body>
                    {
                      (dataTramite && dataTramite.arrOT) ?
                        (dataTramite.arrOT[0]) ? 
                          dataTramite.arrOT[0].info.map((element,index) => (
                            <>
                              <Form.Group key={`${index}`}>
                                <Form.Label><b>{element.nombre}</b></Form.Label>
                                <hr/>
                                {
                                  element.tipo === 'file' ? <Button onClick={() => window.open(`https://wsoft0.s3.amazonaws.com/interbrokers/${element.value}`, '_blank') }><i className="bi bi-eye"></i>&nbsp;Haz clic para visualizar</Button> : <p>{element.value}</p>
                                }
                                {/* <Form.Control as="textarea" type={element.tipo} id={element.id} name={element.id} value={element.value} /> */}
                              </Form.Group>
                            </>
                          ))
                        : null
                      : <p>No hay datos disponibles</p>
                    }
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={6}>
                <div className="ws-box-container mb-2">
                  <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial de pagos ({dataTramite.arrCobranza.length})</h6>
                  <hr />
                  {
                    dataTramite.arrCobranza.length > 0 &&
                    <>
                      <Row>
                        <Col>
                          <b>Forma de pago</b>
                        </Col>
                        <Col>
                          <b>Cantidad</b>
                        </Col>
                        <Col>
                          <b>Archivos</b>
                        </Col>
                      </Row>
                      { dataTramite.arrCobranza && dataTramite.arrCobranza.map((t,e) => (
                        <Row key={e}>
                          <Col>
                            <p style={{ margin: 0, }}>{t.forma_pago}</p>
                          </Col>
                          <Col>
                            <p style={{ margin: 0, }}>${number_format(t.cantidadRecibida, 2)}</p>
                          </Col>
                          <Col>
                          {
                            t.files && t.files.length > 0 &&
                            <ul className="navbar-nav ms-auto ws-dropdown-list">
                              <li className="nav-item dropdown position-static">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                  <i className="bi bi-three-dots-vertical"></i>
                                </a>
                                <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                                  {
                                    t.files.map((t0,e0) => (
                                      <a key={e0} 
                                      onClick={() => {
                                        window.open(t0.url, '_blank')
                                      }} 
                                      className="dropdown-item"
                                      style={{cursor: 'pointer'}}
                                      >
                                        <i className="bi bi-link"></i> {t0.file}
                                      </a>
                                    ))
                                  }
                                </div>
                              </li>
                            </ul>
                          }
                          </Col>
                        </Row>
                        ))
                      }
                    </>
                  }
                </div>
                <div className="ws-box-container">
                  <h6>Bitácora</h6>
                  <hr/>
                {
                  (dataTramite && dataTramite.arrBitacora) ?
                    (dataTramite.arrBitacora.length > 0) ?
                      dataTramite.arrBitacora.map((bitacora,index) =>(
                        <>
                          <p style={{marginBottom:'7px'}}><b>Departamento:</b> <Badge bg="primary" style={{fontSize:'.95rem'}}>{bitacora.area}</Badge> </p>
                          <p style={{marginBottom:'7px',color:'#404040'}}><span style={{fontSize:'.9rem'}}><i className="bi bi-calendar"></i> 16/02/2023</span></p>
                          <p style={{backgroundColor:'#ededed',padding:'5px',borderRadius:'5px',border:'1px solid #dfdfdf'}}><b>Razón:</b> <br />{bitacora.razon}</p>
                          <hr/>
                        </>
                      ))
                    : <p>Aún no hay datos en la bitácora</p>
                  : null
                }
                </div>
              </Col>
            </Row>
          </Container>
          )
        }
      </Modal.Body>
      <Modal.Footer>
        { number_format( (cantidadNumber - totalAbonos) - cantidadRecibida ) >= 0
          && 
          <button 
          disabled={btnIsLoading}
          onClick={() => { realizaCobro() }} 
          className="btn btn-primary ws-btn-blue-2">
            {
              btnIsLoading 
              ?
                <>Guardando... <Spinner animation="border" size="sm" /></>
              :
                'Cobrar'
            }
          </button> 
        }
      </Modal.Footer>
    </Modal>
  )
}

const formMotivo = (props) => {
  return(
    <div> 
      {
        props.children
      }
    </div>
  )
}

const ModalAutorizarTramite = ({ show, handleClose, socket, typeView, reloadData }) => {

  const refNumRef = useRef(null);
  const refMotivo = useRef(null);
  const {usuario} = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  const [cantidadImporte,setCantidadImporte] = useState(0);
  const [referencia,setReferencia] = useState('');
  let { 
    showModalAutorizarTramite,
    newCotizacion,
    dataTramite,
    dataArray,
  } = stateGlobal;

  const [cantidadRecibida, setCantidadRecibida] = useState('');
  const [fileComprobante,setFileComprobante] = useState([]);
  const [btnIsLoading, setBtnIsLoading] = useState(false);
  const refComprobantePago = useRef(null);
  const refLabelComprobantePago = useRef(null);

  const [modalConfirmacionDeclinar,setModalConfirmacionDeclinar] = useState(false);
  const [btnLoadingDeclinarCredito, setBtnLoadingDeclinarCredito] = useState(false);


  const realizaAutorizacion = () => {

    if(referencia === ''){
      alert("Agrega el número de referencia");
      refNumRef.current.focus();
      return false;
    }

    let _dataTramite = [], _tmp = dataTramite

    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.metodo_pago === 'credito') {

        if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
          _dataTramite.push({
            ..._tmp.arrOT[0].arrProcess[a],
            status: _tmp.arrOT[0].arrProcess[a].status === 0 ? 1 : _tmp.arrOT[0].arrProcess[a].status,
          })
        } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
          _dataTramite.push({
            ..._tmp.arrOT[0].arrProcess[a],
            status: 2,
          })
        } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
          _dataTramite.push({
            ..._tmp.arrOT[0].arrProcess[a],
            status: 0,
          })

        } else {
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }

      } else {
        if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
          _dataTramite.push({
            ..._tmp.arrOT[0].arrProcess[a],
            status: 2,
          })
        } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
          _dataTramite.push({
            ..._tmp.arrOT[0].arrProcess[a],
            status: _tmp.arrOT[0].arrProcess[a].status === 0 ? 1 : _tmp.arrOT[0].arrProcess[a].status,
          })

        } else {
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      }


    }

    const dataUpdate = {
      info: dataTramite.arrOT[0].info,
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    setBtnIsLoading(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
     method: 'POST',
     mode: 'cors',
     body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      const dataFinanzas = {
        id_cotizacion: dataTramite.id_cotizacion,
        authorization_finanzas: true,
      }

      const formData = new FormData();
      formData.append('id_cotizacion', dataTramite.id_cotizacion);
      formData.append('etapa_liberacion', dataTramite.metodo_pago);
      formData.append('cantidad_liberada', cantidadImporte);
      formData.append('referencia', referencia);
      formData.append('authorization_finanzas', true);

      fileComprobante.map((t0, e0) => {
        formData.append('files[]', t0)
      })

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateAutorizacionFinanzas',{
        method: 'POST',
        mode: 'cors',
        body: formData,
      })
      .then( response => response.json())
      .then( res => {
        dispatch(showAlert({
          show : true, 
          message : 'Liberación realizada con éxito.',
          type: 'success',
          duration: 3000,
        }))
        setTimeout(() => {
          socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
        },1500)
      })

    })

  }

  let cantidadNumber = 0

  if(dataTramite.cantidad) {
    cantidadNumber = dataTramite.cantidad
  }

  let totalAbonos = 0
  if(dataTramite.arrCobranza) {
    dataTramite.arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
  }

  const compareSaldos = (item) => {

    let cantidad = item.costo_dependencia,
    totalLiberadaAfter = 0
    item.arrLiberaciones.map((t,e) => {
      totalLiberadaAfter += parseFloat(t.cantidad_liberada)
    })

    if(!item.cantidad)
      cantidad = 0

    // console.log(parseFloat(totalLiberadaAfter), parseFloat(cantidadImporte), parseFloat(cantidad) )

    if(cantidadImporte === '') {
      return false
    } else {
      if((parseFloat(totalLiberadaAfter) + parseFloat(cantidadImporte)) == parseFloat(cantidad))
        return true
      else
        return false
    }

  }

  const getCantidadPagada = (item) => {
    let cantidadPagada = 0;
    if(item.length > 0) {
      item.map((t,e) => {
        cantidadPagada += parseFloat(t.cantidadRecibida)
      })
    }
    return cantidadPagada;
  }

  const debeCotizacion = (cantidad,cobranza) => {
    const total = parseFloat(cantidad);
    let sumaDebe = 0;
    cobranza.map((t,e) => {
      sumaDebe += parseFloat(t.cantidadRecibida)
    })
    if(total === sumaDebe){
      return false;
    }else{
      return true;
    }
  }

  const declinarCredito = () => {
    const { dataTramite } = stateGlobal;

    if(refMotivo.current.value===''){
      dispatch( showAlert( {
        show : true, 
        message : 'El motivo es requerido',
        type: 'error',
        duration: 2000,
      } ) )
      refMotivo.current.focus()
      return false;
    }

    let _dataTramite = [], _tmp = dataTramite;
    for(var a in _tmp.arrOT[0].arrProcess) {
      if(_tmp.arrOT[0].arrProcess[a].id === 'cotizaciones'){
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'caja') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status : 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 3,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 3,
        })
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }
    }

    const dataUpdate = {
      arrProcess: _dataTramite,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    setBtnLoadingDeclinarCredito(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {

      const dataBitacora = {
        area: getDepartamento(typeView),
        razon: 'Se rechazo un crédito',
        id_cotizacion: dataTramite.id_cotizacion,
        usuario: usuario.nombre
      }

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataBitacora)
      })
      .then( response => response.json())
      .then( response => {
        setModalConfirmacionDeclinar(false)
        setBtnLoadingDeclinarCredito(false)
        handleClose()
        reloadData()
      })

    })

  }

  if(typeof dataTramite.cantidad === 'undefined')
   return false

  return (
    <React.Fragment>  
      <Modal show={showModalAutorizarTramite} onHide={ () => {
        dispatch( setStateGlobal({ showModalAutorizarTramite: false, }) )
      }} size="lg" fullscreen={false}>
        <Modal.Header closeButton className="ws-modal-header title">
          <Modal.Title><i className="bi bi-pencil-square" style={{fontSize:'1.4rem'}}></i> Liberar fondos a procesos</Modal.Title>
        </Modal.Header>
        <Modal.Body className="ws-modal-body">
        <Container className="ws-box-container">
            <Row>
              <Col xs={12}>
                <div className="ws-tab-container pb-3 mb-3">
                  <Alert variant="secondary"><i className="bi bi-info-circle"></i> <i>Esta acción no se puede deshacer</i></Alert>
                  <p><b>Costo total del trámite:</b> ${number_format(dataTramite.costo_dependencia + dataTramite.costo_honorario)}</p>
                  <p><b>Costo dependencia:</b> ${number_format(dataTramite.costo_dependencia)}</p>
                  <p><b>Método de pago:</b> {dataTramite.metodo_pago}</p>

                  {/* Historial de deuda */}
                  <hr />
                  <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial de deuda del cliente</h6>
                  <Table responsive hover> 
                    <thead> 
                      <tr>  
                        <th>Nombre</th>
                        <th>Servicio</th>
                        <th>Cantidad</th>
                        <th>Cantidad pagada</th> 
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dataArray.map((t,e) => {
                          if(t.id_cliente === dataTramite.id_cliente && t.arrCobranza.length > 0 && debeCotizacion(t.cantidad,t.arrCobranza)){
                            return(
                              <tr>
                                <td>{t.nombre}</td>
                                <td>{t.concepto2}</td>
                                <td>${number_format(t.cantidad)}</td>
                                <td>
                                  ${ number_format(getCantidadPagada(t.arrCobranza)) }
                                </td>
                              </tr>
                            )
                          }else{
                            return null;
                          }
                        })
                      }
                    </tbody>
                  </Table>
                  <hr />
                  <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial de abonos del cliente</h6>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Forma de pago</th>
                        <th>Cantidad</th>
                        <th>Fecha</th>
                        <th>Comprobantes</th>
                      </tr>
                    </thead>
                    <tbody>
                    {
                      dataTramite.arrCobranza.map((t,e) => (
                        <tr key={e}>
                          <td>{t.forma_pago}</td>
                          <td><b>${number_format(t.cantidadRecibida)}</b></td>
                          <td>{moment(t.created_at).format('DD/MM/YYYY HH:mm')}</td>
                          <td>
                            {
                              t.files && t.files.length > 0 &&
                              <ul className="navbar-nav ms-auto ws-dropdown-list">
                                <li className="nav-item dropdown position-static">
                                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                                    {
                                      t.files.map((t0,e0) => (
                                        <a key={e0} 
                                        onClick={() => {
                                          window.open(t0.url, '_blank')
                                        }} 
                                        className="dropdown-item"
                                        style={{cursor: 'pointer'}}
                                        >
                                          <i className="bi bi-link"></i> {t0.file}
                                        </a>
                                      ))
                                    }
                                  </div>
                                </li>
                              </ul>
                            }
                          </td>
                        </tr>
                      ))
                    }
                    </tbody>
                  </Table>

                  <hr />
                  <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial liberaciones de finanzas ({dataTramite.arrLiberaciones.length})</h6>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Referencia</th>
                        <th>Etapa de trámite</th>
                        <th>Cantidad</th>
                        <th>Fecha</th>
                        <th>Comp.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dataTramite.arrLiberaciones.map((t,e) => (

                          <tr key={e}>
                            <td>{t.referencia}</td>
                            <td>{t.etapa_liberacion}</td>
                            <td><b>${number_format(t.cantidad_liberada)}</b></td>
                            <td>{moment(t.created_at).format('DD/MM/YYYY HH:mm')}</td>
                            <td>
                            {
                              t.files && t.files.length > 0 &&
                              <ul className="navbar-nav ms-auto ws-dropdown-list">
                                <li className="nav-item dropdown position-static">
                                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                                    {
                                      t.files.map((t0,e0) => (
                                        <a key={e0} 
                                        onClick={() => {
                                          window.open(t0.url, '_blank')
                                        }} 
                                        className="dropdown-item"
                                        style={{cursor: 'pointer'}}
                                        >
                                          <i className="bi bi-link"></i> {t0.file}
                                        </a>
                                      ))
                                    }
                                  </div>
                                </li>
                              </ul>
                            }
                            </td>
                          </tr>

                        ))
                      }
                    </tbody>
                  </Table>
                  
                  <hr />
                  <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Nueva liberación de pago a procesos</h6>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="3" className="text-lg-end">
                      <p><b>Subir comprobantes:</b></p>
                    </Col>
                    <Col sm="9">
                      {
                        fileComprobante.length > 0 &&
                          <div>
                          { fileComprobante.map((t, e) => {
                            return (
                              <Row className="mb-2">
                                <Col> 
                                  <h6 key={e} className="mb-0">{t.name}&nbsp;</h6>
                                </Col>
                                <Col> 
                                  - <Button 
                                  className="ws-btn-blue-2"
                                  onClick={
                                    () => {
                                      let newFileComprobante = [...fileComprobante];
                                      newFileComprobante.splice(e,1);
                                      setFileComprobante(newFileComprobante);
                                      // console.log(newFileComprobante);
                                    }
                                  }
                                  >Quitar</Button>
                                </Col>
                              </Row> 
                            )
                          }) }
                          </div>
                      }

                      {
                        fileComprobante.length < 1 && (
                        <Form.Label ref={refLabelComprobantePago} labelfor="fileCobrarComprobante" className="btn btn-primary ws-btn-blue-2 label-button">
                          <h6 className="mb-0"><>Subir comprobantes de fondos</>&nbsp;<i className="bi bi-upload"></i></h6>
                          <Form.Control ref={refComprobantePago} type="file" multiple={true} name="fileCobrarComprobante" id="fileCobrarComprobante" style={{display:'none'}} onChange={ (file) => {
                            let array = []
                            for(var a in file.target.files) {
                              if(typeof file.target.files[a] === 'object') {
                                array.push(file.target.files[a])
                              }
                              if(a == (file.target.files.length - 1)) {
                                setFileComprobante(array)
                              }
                            }
                          } } />

                        </Form.Label>
                        )
                      }

                    </Col>
                  </Form.Group>

                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Número de referencia</Form.Label>
                      <Form.Control ref={refNumRef} type={'text'} onChange={(ev)=> { setReferencia(ev.target.value) }} placeholder={'Ingresa el número de referencia...'} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Importe</Form.Label>
                      <Form.Control type={'text'} onChange={(ev)=> { setCantidadImporte(ev.target.value) }} placeholder={'Ingresa el importe...'} />
                    </Form.Group>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          {
            dataTramite.metodo_pago === 'credito' && (
              <Button 
              className="ws-btn-blue-2"
              onClick={ () => {
                setModalConfirmacionDeclinar(true);
              }}
              >Declinar</Button>
            )
          }
          {
            compareSaldos(dataTramite) ? 
              <button 
              disabled={btnIsLoading}
              onClick={() => { realizaAutorizacion(dataTramite.cantidad) }} 
              className="btn btn-primary ws-btn-blue-2">
                { btnIsLoading ? <>Guardando... <Spinner animation="border" size="sm" /></> : dataTramite.metodo_pago==='credito' ? 'Aprobar' : 'Continuar' }
              </button>
            : 
              <p>Por favor, verifica el monto ingresado con el solicitado o faltante.</p>
          }
        </Modal.Footer>
      </Modal>

      <ModalConfirmacion 
      show={modalConfirmacionDeclinar} 
      message={<p className="mb-0">¿Deseas declinar este crédito?</p>} 
      handleDelete={ () => declinarCredito() }
      handleCancel={ () => setModalConfirmacionDeclinar(false) }
      textConfirm={'Confirmar'}
      textCancel={'Cancelar'}
      isLoading={btnLoadingDeclinarCredito}
      children={
        <formMotivo>
          <Form className="mt-2">
            <Form.Group>
              <Form.Label>Agrega el motivo</Form.Label>
              <Form.Control ref={refMotivo} as="textarea" row="5" />
            </Form.Group>
          </Form>
        </formMotivo>
      }
      />
    </React.Fragment>
  )

}

const ModalModificarCostoTramite = ({ show, handleClose, socket }) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  const refNuevoMonto = useRef(null);
  const refRazon = useRef(null);

  const [cantidadImporte,setCantidadImporte] = useState("");
  const [razon,setRazon] = useState("");
  const [btnIsLoading,setBtnIsLoading] = useState(false);
  const [alerta,setAlerta] = useState({
    show: false,
    message: '',
  });

  let { 
    showModalModificarCostoTramite,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  const realizaAutorizacion = () => {

    if(cantidadImporte===""){
      setAlerta( prevState => ({
        ...prevState,
        show: true,
        message : 'Por favor ingresa el nuevo monto.'
      }) )
      refNuevoMonto.current.focus();
      return false;
    }

    if(razon===""){
      setAlerta( prevState => ({
        ...prevState,
        show: true, 
        message: 'Por favor ingresa una razón.'
      }) )
      refRazon.current.focus();
      return false;
    }

    setAlerta( prevState => ({
      ...prevState,
      show: false,
      message: ''
    }) )

    let _dataTramite = [], _tmp = dataTramite

    const dataUpdate = {
      // ...dataTramite,
      id_cotizacion: dataTramite.id_cotizacion,
      cantidad: cantidadImporte,
      motivo: refRazon.current.value
    }

    setBtnIsLoading(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateCantidadTramiteById',{
     method: 'POST',
     mode: 'cors',
     body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      let _dataTramite = [], _tmp = dataTramite, canProcess = false


      for(var a in _tmp.arrOT[0].arrProcess) {
        if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 0, })
        } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 0, })
        } else {
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      }

      const dataUpdate = {
        arrProcess: _dataTramite,
        id_tramite_ot: dataTramite.id_cotizacion,
        id_cotizacion: dataTramite.id_cotizacion,
      }
   
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(dataUpdate),
      })
      .then( response => response.json())
      .then( response => {
        dispatch(showAlert({
          show : true, 
          message : 'Costo actualizado con éxito.',
          type: 'success',
          duration: 3000,
        }))
        setTimeout(() => {
          socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', })  
        },1500)
      })

    })
  }

  return (
    <Modal show={showModalModificarCostoTramite} onHide={ () => {
      dispatch( setStateGlobal({ showModalModificarCostoTramite: false, }) )
    }} size="lg" fullscreen={false}>
      <Modal.Header closeButton className="ws-modal-header title">
        <Modal.Title><i className="bi bi-pencil-square" style={{fontSize:'1.3rem'}}></i> Modificar costo del trámite</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3">
                <Alert variant="secondary"><i className="bi bi-info-circle"></i> <i>Esta acción notificará al cliente sobre el cambio de costo y se recalculará sobre lo que ha pagado.</i></Alert>
                { (alerta.show) && <Alert variant="danger"><i className="bi bi-x-octagon-fill"></i>&nbsp;{alerta.message}</Alert> }
                <div className="ws-box-container">
                  <p><b>Cantidad actual:</b> ${number_format(dataTramite.costo_dependencia)}</p>
                  <hr />
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>Nuevo Monto</Form.Label>
                      <Form.Control ref={refNuevoMonto} type={'text'} onChange={(ev)=> { setCantidadImporte(ev.target.value) }} placeholder={'Ingresa el nuevo monto'} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Razón</Form.Label>
                      <Form.Control ref={refRazon} as="textarea" cols={5} rows={3}  placeholder="Ingresa la razón del por que se está actualizando el costo." onChange={ (e) => setRazon(e.target.value) } />
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
      {
        parseFloat(cantidadImporte) > parseFloat(dataTramite.costo_dependencia) &&
        <button 
        disabled={btnIsLoading}
        onClick={() => { realizaAutorizacion(cantidadImporte) }} 
        className="btn btn-primary ws-btn-blue-2">
          {
            btnIsLoading ?
              <>Guardando... <Spinner animation="border" size="sm" /></>
            : 
              <><i className="bi bi-check-circle-fill"></i> Aumentar costo</>
          }
        </button>
      }
      </Modal.Footer>
    </Modal>
  )
}

const ModalFinalizarProceso = ({ show, handleClose, socket }) => {

  const refFechaRenovacion = useRef(null);
  const refLabelDocumento = useRef(null);
  const refInputDocumento = useRef(null);
  const refObservaciones = useRef(null);

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalFinalizarProceso,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  const [cantidadRecibida, setCantidadRecibida] = useState('');
  const [fileDocumentoProcesos,setFileDocumentoProcesos] = useState([]);
  const [btnIsLoading,setBtnIsLoading] = useState(false);
  const [alerta,setAlerta] = useState({
    isError: false,
    errorMessage : ''
  })

  const realizaFinalizaProceso = () => {

    if(dataTramite.departamento==='Services'){
      if(refFechaRenovacion.current.value==='') {
        setAlerta( prevState => ({
          ...prevState,
          isError: true,
          errorMessage : 'Selecciona la fecha de renovación'
        }))
        refFechaRenovacion.current.focus();
        return false;
      }
    }

    if(refInputDocumento.current !== null){
      if(refInputDocumento.current.value==='') {
        setAlerta( prevState => ({
          ...prevState,
          isError: true,
          errorMessage: 'Adjunta el documento'
        }))
        refLabelDocumento.current.classList.add('label-button-focus');
        return false;
      }
      refLabelDocumento.current.classList.remove('label-buton-focus');
    }

    if(refObservaciones.current.value===''){
      setAlerta( prevState => ({
        ...prevState,
        isError: true,
        errorMessage: 'Ingresa una observación'
      }));
      refObservaciones.current.focus();
      return false;
    }

    setAlerta( prevState => ({  ...prevState, isError: false, errorMessage: '' }));

    let _dataTramite = [], _tmp = dataTramite
    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 4,
        })
      } else {

        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 2,
        })
      }
    }

    let dataUpdate = {}

    if(dataTramite.departamento === 'Services'){
      dataUpdate = {
        info: dataTramite.arrOT[0].info,
        arrProcess: _dataTramite,
        id_tramite_ot: dataTramite.id_cotizacion,
        id_cotizacion: dataTramite.id_cotizacion,
        fecha_renovacion: refFechaRenovacion.current.value,
      }
    }else{
      dataUpdate = {
        info: dataTramite.arrOT[0].info,
        arrProcess: _dataTramite,
        id_tramite_ot: dataTramite.id_cotizacion,
        id_cotizacion: dataTramite.id_cotizacion,
      }
    }
    
    setBtnIsLoading(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {

      if(fileDocumentoProcesos.length > 0) {
        const formData = new FormData();
        formData.append('id_cotizacion', dataTramite.id_cotizacion)
        formData.append('observaciones', refObservaciones.current.value)
        // formData.append('file', refInputDocumento.current.files[0])
        fileDocumentoProcesos.map((t0, e0) => {
          formData.append('files[]', t0)
        })

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOtFile', {
          method: 'POST',
          mode: 'cors',
          body: formData
        })
        .then( response => response.json())
        .then( res => {
          // alert('¡Proceso finalizado con éxito!')
          dispatch( showAlert( {
            show : true, 
            message : '¡Proceso finalizado con éxito!',
            type: 'success',
            duration: 3000,
          } ) )
          socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
        })
      }else{
        dispatch( showAlert( {
          show : true, 
          message : '¡Proceso finalizado con éxito!',
          type: 'success',
          duration: 3000,
        } ) )
  
        setTimeout(() => {
          socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', })
        }, 1500)
      }

    })
  }

  let cantidadNumber = 0

  if(dataTramite.cantidad) {
    cantidadNumber = dataTramite.cantidad
  }

  return (
    <Modal show={showModalFinalizarProceso} onHide={ () => {
      dispatch( setStateGlobal({ showModalFinalizarProceso: false, }) )
    }} size="lg" fullscreen={false}>
      <Modal.Header closeButton className="ws-modal-header title">
        <Modal.Title>¡Finalizar proceso!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Alert variant="secondary"><i className="bi bi-info-circle"></i> <i>Esta acción no se puede deshacer</i></Alert>
                <hr />
                <p>Departamento: <b>{dataTramite.departamento}</b></p>
                {
                  dataTramite.departamento === 'Services' && (
                    <Form.Group className="mb-3">
                      <Form.Label>Fecha de renovación</Form.Label>
                      <Form.Control ref={refFechaRenovacion} type="date"  />
                    </Form.Group>
                  )
                }

                <Form.Group as={Row} className="mb-2">
                  <Col sm="3" className="text-lg-end">
                    <p><b>Subir comprobantes:</b></p>
                  </Col>
                  <Col sm="9">
                    {
                      fileDocumentoProcesos.length > 0 &&
                        <div>
                        { fileDocumentoProcesos.map((t, e) => {
                          return (
                            <Row className="mb-2">
                              <Col> 
                                <h6 key={e} className="mb-0">{t.name}&nbsp;</h6>
                              </Col>
                              <Col> 
                                - <Button 
                                className="ws-btn-blue-2"
                                onClick={
                                  () => {
                                    let newFileComprobante = [...fileDocumentoProcesos];
                                    newFileComprobante.splice(e,1);
                                    setFileDocumentoProcesos(newFileComprobante);
                                    // console.log(newFileComprobante);
                                  }
                                }
                                >Quitar</Button>
                              </Col>
                            </Row> 
                          )
                        }) }
                        </div>
                    }

                    {
                      fileDocumentoProcesos.length < 1 && (
                        <Form.Label ref={refLabelDocumento} labelfor="fileFinalizar" className="btn btn-primary ws-btn-blue-2 label-button">
                          <h6 className="mb-0"><>Subir comprobantes de pago</>&nbsp;<i className="bi bi-upload"></i></h6>
                  
                          <Form.Control ref={refInputDocumento} type="file" multiple={true} name="fileFinalizar" id="fileFinalizar" style={{display:'none'}} onChange={ (file) => {
                            let array = []
                            for(var a in file.target.files) {
                              if(typeof file.target.files[a] === 'object') {
                                array.push(file.target.files[a])
                              }
                              if(a == (file.target.files.length - 1)) {
                                setFileDocumentoProcesos(array)
                              }
                            }
                          } } />

                        </Form.Label>
                      )
                    }
                    
                  </Col>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label labelfor="observaciones">Observaciones</Form.Label>
                  <Form.Control ref={refObservaciones} rows={5} as="textarea" name="observaciones" id="observaciones" />
                </Form.Group>
                {
                    alerta.isError && <Alert variant="danger"><i className="bi bi-x-octagon-fill"></i>&nbsp;{alerta.errorMessage}</Alert>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button 
        disabled={btnIsLoading}
        onClick={() => { realizaFinalizaProceso() }} 
        className="btn btn-primary ws-btn-blue-2"
        >
          {
            btnIsLoading  
            ?
              <>Finalizando... <Spinner animation="border" size="sm" /></>
            :
              'Finalizar'
          }
          
        </button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalNotificarCliente = ({ show, handleClose, socket }) => {

  const refLabelDocumento = useRef(null);
  const refInputDocumento = useRef(null);
  const refObservaciones = useRef(null);

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalNotificarCliente,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  const [alerta,setAlerta] = useState({
    isError: false,
    errorMessage : ''
  })
  const [fileDocumentoEvidencia,setFileDocumentoEvidencia] = useState('');


  const realizaFinalizaNotificacion = () => {
    /*
    if(refInputDocumento.current.value==='') {
      setAlerta( prevState => ({
        ...prevState,
        isError: true,
        errorMessage: 'Adjunta el documento'
      }))
      refLabelDocumento.current.classList.add('label-button-focus');
      return false;
    }
    refLabelDocumento.current.classList.remove('label-buton-focus');
    */

    if(refObservaciones.current.value===''){
      setAlerta( prevState => ({
        ...prevState,
        isError: true,
        errorMessage: 'Ingresa una observación'
      }));
      refObservaciones.current.focus();
      return false;
    }

    setAlerta( prevState => ({  ...prevState, isError: false, errorMessage: '' }));

    let _dataTramite = [], _tmp = dataTramite
    for(var a in _tmp.arrOT[0].arrProcess) {
      _dataTramite.push({
        ..._tmp.arrOT[0].arrProcess[a],
        status: 2,
      })
    }

    let dataUpdate = {}
  
    dataUpdate = {
      info: dataTramite.arrOT[0].info,
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
      observaciones_notificacion: refObservaciones.current.value
    }
    
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {

      dispatch( showAlert( {
        show : true, 
        message : '¡Aviso finalizado con éxito!',
        type: 'success',
        duration: 3000,
      } ) )

      setTimeout(() => {
        socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', })
      }, 1500)

      /*
      [W] Corregir: Falta saber que se hará con este modal
      const formData = new FormData();
      formData.append('id_cotizacion', dataTramite.id_cotizacion)
      formData.append('file', refInputDocumento.current.files[0])

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateNotificacionOtFile', {
        method: 'POST',
        mode: 'cors',
        body: formData
      })
      .then( response => response.json())
      .then( res => {
        alert('¡Proceso finalizado con éxito!')
        socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
      })
      */

    })
  }

  return (
    <Modal show={showModalNotificarCliente} onHide={ () => {
      dispatch( setStateGlobal({ showModalNotificarCliente: false, }) )
    }} size="lg" fullscreen={false}>
      <Modal.Header closeButton className="ws-modal-header title">
        <Modal.Title>¡Notificar al cliente!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">
                <Alert variant="secondary"><i className="bi bi-info-circle"></i> <i>Debes confirmar que tu cliente fue notificado de su trámite finalizado.</i></Alert>
                <hr />

                <h5>Achivos procesos</h5>  
                <div className="ws-box-container">
                  <Row>
                    <Col md={8} lg={8} xs={8}>
                      <b>Archivo</b>
                    </Col>
                    <Col md={4} lg={4} xs={4}>
                      <b>Compartir</b>
                    </Col>
                  </Row>
                  <Row> 
                    <Col xs={12}>
                      <hr />
                    </Col>
                  </Row>

                  { dataTramite.arrProcesos && dataTramite.arrProcesos.map((t,e) => (
                    <>
                      {
                        t.files && t.files.length > 0 && t.files.map((t0,e0) => (
                          <>
                            {
                              t0.selected === false &&
                              <Row key={e}>
                                <Col md={8} lg={8} xs={8}>
                                  <p style={{ cursor: 'pointer', }} onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} ><i className="bi bi-link"></i> {t0.file}</p>
                                </Col>
                                <Col md={4} lg={4} xs={4}>
                                  <p className="btn btn-primary ws-btn-blue-2" style={{ cursor: 'pointer', }} onClick={ () => {
                                    const newArr = JSON.parse( JSON.stringify( dataTramite ) )
                                    newArr.arrProcesos[e].files[e0].selected = !newArr.arrProcesos[e].files[e0].selected
                                    console.log('newArr', newArr)
                                    dispatch( setStateGlobal({ dataTramite: newArr, }) )
                                  }}>{
                                    !t0.selected ? <><i class="bi bi-share-fill"></i> Pulsa para compartir</> : 'Pulsa para dejar de compartir'
                                  }</p>
                                </Col>
                              </Row>
                            }
                          </>
                        ))
                      }
                    </>
                    ))
                  }
                </div>

                <h5 className="mt-3">Achivos a enviar al cliente</h5>  
                <div className="ws-box-container">
                  <Row>
                    <Col md={8} lg={8} xs={8}>
                      <b>Archivo</b>
                    </Col>
                    <Col md={4} lg={4} xs={4}>
                      <b>Compartir</b>
                    </Col>
                  </Row>
                  <Row> 
                    <Col xs={12}>
                      <hr />
                    </Col>
                  </Row>

                  { dataTramite.arrProcesos && dataTramite.arrProcesos.map((t,e) => (
                    <>
                      {
                        t.files && t.files.length > 0 && t.files.map((t0,e0) => (
                          <>
                            {
                              t0.selected === true &&
                              <Row key={e}>
                                <Col md={8} lg={8} xs={8}>
                                  <p style={{ cursor: 'pointer', }} onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} ><i className="bi bi-link"></i> {t0.file}</p>
                                </Col>
                                <Col md={4} lg={4} xs={4}>
                                  <p className="btn btn-primary ws-btn-blue-2" style={{ cursor: 'pointer', }} onClick={ () => {
                                    const newArr = JSON.parse( JSON.stringify( dataTramite ) )
                                    newArr.arrProcesos[e].files[e0].selected = !newArr.arrProcesos[e].files[e0].selected
                                    console.log('newArr', newArr)
                                    dispatch( setStateGlobal({ dataTramite: newArr, }) )
                                  }}>{
                                    !t0.selected ? <><i class="bi bi-share-fill"></i> Pulsa para compartir</> : <><i class="bi bi-x-lg"></i> Dejar de compartir</>
                                  }</p>
                                </Col>
                              </Row>
                            }
                          </>
                        ))
                      }
                    </>
                    ))
                  }
                </div>
                
                <h5 className="mt-3">Observaciones</h5>
                <Form.Group className="mb-3 ws-box-container">
                  <Form.Label labelfor="observaciones">Observación</Form.Label>
                  <Form.Control ref={refObservaciones} rows={5} as="textarea" name="observaciones" id="observaciones" placeholder="Ingresa una observación si así lo deseas..." />
                </Form.Group>
                { alerta.isError && <Alert variant="danger"><i className="bi bi-x-octagon-fill"></i>&nbsp;{alerta.errorMessage}</Alert> }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <p>Al notificar se enviará el documento que compartió procesos.</p>
        <button onClick={() => { realizaFinalizaNotificacion() }} className="btn btn-primary ws-btn-blue-2">Notificar</button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalTwoColumnsOt = ({title,show,handleClose,id_tramite,socket,typeView}) => {
  const {usuario} = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  let { 
    dataTramite,
  } = stateGlobal;

  const [tramites,setTramites] = useState([]);
  const [bitacoras,setBitacoras] = useState([]);
  const [editarOT,setEditarOT] = useState(false);
  const [dataModificaInputsOT, setModificaOT] = useState([]);
  const [viewBitacora,setViewBitacora] = useState(false);
  const [razonBitacora,setRazonBitacora] = useState("");

  useEffect(() => {
    if(show) {
      getTramitesOt();
      getBitacoras();
      setModificaOT( JSON.parse( JSON.stringify(dataTramite.arrOT[0].info ) ) )
    }
  },[show])

  const getItemByArrProcess = (_item, id) => {
    let itemTramite, _tmp = _item
    // Posición 0 en arrOT significa le primer trámite (pensamos en un multitrámites en algún momento)
    const arrProcess = _tmp.arrOT[0].arrProcess
    for(var a in arrProcess) {
      if(arrProcess[a].id === id) {
        itemTramite = arrProcess[a]
      }
    }
    return itemTramite
  }

  const getTramitesOt = () => {
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesOt',{
      method: 'POST',
      mode: 'cors'
    })
    .then( response => response.json())
    .then ( res => {
      setTramites(res.documents)
    })
  }

  const getBitacoras = () => {
    const data = {
      id_tramite: dataTramite.id_cotizacion
    }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getBitacoraByIdTramite',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then ( res => {
      setBitacoras(res.documents)
    })
  }

  const getTotalLiberado = (dataTramite) => {
    let totalAbonos = 0
    if(dataTramite.arrLiberaciones) {
      dataTramite.arrLiberaciones.map((t,e) => {
        totalAbonos += parseFloat(t.cantidad_liberada)
      })
    }
    return totalAbonos
  }

  const isPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    console.log('totalAbonos1: ', (parseFloat(cantidad) - totalAbonos));
    return ( (parseFloat(cantidad) - totalAbonos) <= 0) ? true : false;
  }

  const updateOT = () => {

    let _dataTramite = [], _tmp = dataTramite, canProcess = false

    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        let status = 2
        _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
        if(isPayed(dataTramite) && _tmp.arrOT[0].arrProcess[a].status === 0 && dataTramite.metodo_pago === 'contado') {
          let status = 1;
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
        }else{
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        // canProcess = _tmp.arrOT[0].arrProcess[a - 1].status === 2 ? true : false
        if(isPayed(dataTramite) && _tmp.arrOT[0].arrProcess[a - 1].status === 2){
          let status = 1;
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
        }else{
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }

    }

    const dataUpdate = {
      info: dataModificaInputsOT,
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    console.log('dataUpdate',dataUpdate);

    dataModificaInputsOT.map((form) => {
      if(form.tipo=='file' && typeof form.file !== 'undefined') {
        let formData = new FormData();
        formData.append('id', form.value)
        formData.append('files',form.file)

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveFileTramite',{
          method: 'POST',
          mode: 'cors',
          body: formData,
        }).then( response => response.json())
        .then( response => {

          dispatch(showAlert({
            show : true, 
            message : 'Documento / imagen subida con éxito.',
            type: 'success',
            duration: 3000,
          }))

        })

      }
    })

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( showAlert( {
        show : true, 
        message : 'Orden de trabajo terminada con éxito.',
        type: 'success',
        duration: 3000,
      } ) )
      socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
    })

    return false
  }

  const handleSubmitBitacora = (e) => {
    e.preventDefault();
    

    const dataBitacora = {
      area: getDepartamento(typeView),
      razon: razonBitacora,
      id_cotizacion: dataTramite.id_cotizacion,
      usuario: usuario.nombre,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataBitacora)
    })
    .then( response => response.json())
    .then( response => {
      getBitacoras();
    })
  }

  let dataFilter = [];
  if(tramites.length > 0) {
    dataFilter = tramites.filter( element  => element.id_cotizacion == dataTramite.id_cotizacion);
  }

  if(dataFilter.length === 0)
    return null



return(
    <Modal show={show} onHide={handleClose} size="xl" fullscreen={false}>
      <Modal.Header closeButton className="title">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Row>
          <Col xs={12}>
            <h5><i className="bi bi-person-bounding-box" style={{fontSize:'1.5rem'}}></i> {dataTramite.nombre}</h5>
            <h6 style={{color:'#707070'}}><i className="bi bi-file-earmark-text" style={{fontSize:'1.5rem'}}></i> {dataTramite.concepto2}</h6>
            <hr />
            {
              dataTramite && dataTramite?.arrOT[0]?.fecha_renovacion && (
                <h6><i class="bi bi-calendar-event"></i> Fecha de renovación: { moment(dataTramite.arrOT[0]?.fecha_renovacion).format('DD/MM/YYYY')}</h6>
              )
            }
          </Col>
          <Col xs={12} md={6}>
            <Card>
              <Card.Body>
                {
                  usuario.tipo_usuario === "1" && getItemByArrProcess(dataTramite,'orden_trabajo')?.status === 1 ?
                    <Button className="ws-btn-blue-2" onClick={ () => setEditarOT(!editarOT)}>{!editarOT ? 'Modificar orden de trabajo' : 'Cancelar modificación'}</Button> 
                  :
                    null
                }
                { (editarOT) && <Button className="ws-btn-blue-2 ms-2" onClick={ () => updateOT() }>Guardar cambios</Button> }
                <hr/>
                {
                  (!editarOT) ?
                    (dataFilter.length > 0) ?
                      (dataFilter[0].info) ? 
                        dataFilter[0].info.map((element,index) => (
                          <Form.Group key={`${index}`}>
                            <Form.Label><b>{element.nombre}</b></Form.Label>
                            <hr/>
                            {
                              element.tipo === 'file' ? <Button onClick={() => window.open(`https://wsoft0.s3.amazonaws.com/interbrokers/${element.value}`, '_blank') }><i className="bi bi-eye"></i>&nbsp;Haz clic para visualizar</Button> : <p>{element.value}</p>
                            }
                            {/* <Form.Control as="textarea" type={element.tipo} id={element.id} name={element.id} value={element.value} /> */}
                          </Form.Group>
                        ))
                      : null
                    : <p>No hay datos disponibles</p>
                  : 
                  <Form>
                    <Row className="ws-form-group-divider pb-3 pt-3">
                      {
                        dataFilter[0].info.map((t,e) => (
                          <Col key={`list-${e}`} xs={12} lg={12}>
                            <Form.Group className="mb-2">
                              <Form.Label className="ws-form-label">  
                                {t.nombre}
                              </Form.Label>
                              <Form.Control defaultValue={ t.tipo==='file' ? null : dataFilter[0].info[e].value }  name={t.id} type={t.tipo} multiple={(t.tipo==='file') ? true : false}
                              onChange={ (ev) => {
                                if(t.tipo==='file') {
                                  const id = uniqid()
                                  dataFilter[0].info[e].value = id
                                  dataFilter[0].info[e].file = ev.target.files[0]
                                } else {
                                  dataFilter[0].info[e].value = ev.target.value
                                }

                                setModificaOT(dataFilter[0].info)
                              } }

                              />
                            </Form.Group>
                          </Col>
                        ))
                      }
                      <hr />
                    </Row>
                  </Form>
                }
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <div className="ws-box-container mb-2">
              <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial de pagos ({dataTramite.arrCobranza.length})</h6>
              <hr />
              {
                dataTramite.arrCobranza.length > 0 &&
                <>
                  <Row>
                    <Col>
                      <b>Forma de pago</b>
                    </Col>
                    <Col>
                      <b>Cantidad</b>
                    </Col>
                    <Col>
                      <b>Archivos</b>
                    </Col>
                  </Row>
                  { dataTramite.arrCobranza && dataTramite.arrCobranza.map((t,e) => (
                    <Row key={e}>
                      <Col>
                        <p style={{ margin: 0, }}>{t.forma_pago}</p>
                      </Col>
                      <Col>
                        <p style={{ margin: 0, }}>${number_format(t.cantidadRecibida, 2)}</p>
                      </Col>
                      <Col>
                      {
                        t.files && t.files.length > 0 &&
                        <ul className="navbar-nav ms-auto ws-dropdown-list">
                          <li className="nav-item dropdown position-static">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                              <i className="bi bi-three-dots-vertical"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                              {
                                t.files.map((t0,e0) => (
                                  <a key={e0} 
                                  onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} 
                                  className="dropdown-item"
                                  style={{cursor: 'pointer'}}
                                  >
                                    <i className="bi bi-link"></i> {t0.file}
                                  </a>
                                ))
                              }
                            </div>
                          </li>
                        </ul>
                      }
                      </Col>
                    </Row>
                    ))
                  }
                </>
              }
            </div>

            <div className="ws-box-container mb-2">
              <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial liberaciones de finanzas ({dataTramite.arrLiberaciones.length})</h6>
              <hr />
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Referencia</th>
                    <th>Etapa de trámite</th>
                    <th>Cantidad</th>
                    <th>Fecha</th>
                    <th>Comp.</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataTramite.arrLiberaciones.map((t,e) => (

                      <tr key={e}>
                        <td>{t.referencia}</td>
                        <td>{t.etapa_liberacion}</td>
                        <td><b>${number_format(t.cantidad_liberada)}</b></td>
                        <td>{moment(t.created_at).format('DD/MM/YYYY HH:mm')}</td>
                        <td>
                        {
                          t.files && t.files.length > 0 &&
                          <ul className="navbar-nav ms-auto ws-dropdown-list">
                            <li className="nav-item dropdown position-static">
                              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                <i className="bi bi-three-dots-vertical"></i>
                              </a>
                              <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                                {
                                  t.files.map((t0,e0) => (
                                    <a key={e0} 
                                    onClick={() => {
                                      window.open(t0.url, '_blank')
                                    }} 
                                    className="dropdown-item"
                                    style={{cursor: 'pointer'}}
                                    >
                                      <i className="bi bi-link"></i> {t0.file}
                                    </a>
                                  ))
                                }
                              </div>
                            </li>
                          </ul>
                        }
                        </td>
                      </tr>

                    ))
                  }
                </tbody>
              </Table>
            </div>

            <div className="ws-box-container mb-2">
              <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial liberaciones de procesos ({dataTramite.arrProcesos.length})</h6>
              <hr />
              {
                dataTramite.arrProcesos.length > 0 &&
                <>
                  <Row>
                    <Col md={7} lg={7} xs={7}>
                      <b>Observación</b>
                    </Col>
                    <Col md={3} lg={3} xs={3}>
                      <b>Fecha</b>
                    </Col>
                    <Col md={2} lg={2} xs={2}>
                      <b>Archivos</b>
                    </Col>
                  </Row>
                  { dataTramite.arrProcesos && dataTramite.arrProcesos.map((t,e) => (
                    <Row key={e}>
                      <Col md={7} lg={7} xs={7}>
                        <p style={{ margin: 0, }}>{t.observaciones}</p>
                      </Col>
                      <Col md={3} lg={3} xs={3}>
                        <p style={{ margin: 0, }}>{t.created_at}</p>
                      </Col>
                      <Col md={2} lg={2} xs={2}>
                      {
                        t.files && t.files.length > 0 &&
                        <ul className="navbar-nav ms-auto ws-dropdown-list">
                          <li className="nav-item dropdown position-static">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                              <i className="bi bi-three-dots-vertical"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                              {
                                t.files.map((t0,e0) => (
                                  <a key={e0} 
                                  onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} 
                                  className="dropdown-item"
                                  style={{cursor: 'pointer'}}
                                  >
                                    <i className="bi bi-link"></i> {t0.file}
                                  </a>
                                ))
                              }
                            </div>
                          </li>
                        </ul>
                      }
                      </Col>
                    </Row>
                    ))
                  }
                </>
              }
            </div>
            <div className="ws-box-container mb-2">
              <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Bitácora</h6>
              <Button className="ws-btn-blue-2" onClick={() => setViewBitacora(!viewBitacora)}>Agregar</Button>
              {
                (viewBitacora) ?
                <Form onSubmit={handleSubmitBitacora}>  
                  <Form.Group className="mt-2 mb-2">
                    <Form.Label>Escribe una anotación</Form.Label>  
                    <Form.Control required value={razonBitacora} as="textarea" rows={4} onChange={
                      (e) => {
                        setRazonBitacora(e.target.value);
                      }
                    } placeholder="Escribe una anotación para registrar en la bitácora" />
                  </Form.Group>
                  <Form.Group>
                    <Button type="submit">Guardar</Button>
                  </Form.Group>
                </Form>
                : null
              }
              <hr/>
            {
              (bitacoras.length > 0) ?
                bitacoras.map((bitacora,index) =>(
                  <div key={index}>
                    <p style={{marginBottom:'7px'}}><b>Departamento: </b> <Badge bg="primary" style={{fontSize:'.95rem'}}>{bitacora.area}</Badge> </p>
                    <p style={{marginBottom:'7px',color:'#404040'}}><span style={{fontSize:'.9rem'}}><i className="bi bi-calendar"></i> { moment(bitacora.created_at).format('DD/MM/YYYY HH:mm') }</span></p>
                    <p style={{backgroundColor:'#ededed',padding:'5px',borderRadius:'5px',border:'1px solid #dfdfdf'}}><b>Razón:</b> <br />{bitacora.razon}</p>
                    <hr/>
                  </div>
                ))
              : <p>Aún no hay datos en la bitácora</p>
            }
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

const ModalTwoColumnsOtProcesos = ({title,show,handleClose,id_tramite,socket,typeView}) => {
  const {usuario} = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  let { 
    dataTramite,
  } = stateGlobal;

  const [tramites,setTramites] = useState([]);
  const [bitacoras,setBitacoras] = useState([]);
  const [editarOT,setEditarOT] = useState(false);
  const [dataModificaInputsOT, setModificaOT] = useState([]);
  const [viewBitacora,setViewBitacora] = useState(false);
  const [razonBitacora,setRazonBitacora] = useState("");

  useEffect(() => {
    if(show) {
      getTramitesOt();
      getBitacoras();
      setModificaOT( JSON.parse( JSON.stringify(dataTramite.arrOT[0].info ) ) )
    }
  },[show])

  const getItemByArrProcess = (_item, id) => {
    let itemTramite, _tmp = _item
    // Posición 0 en arrOT significa le primer trámite (pensamos en un multitrámites en algún momento)
    const arrProcess = _tmp.arrOT[0].arrProcess
    for(var a in arrProcess) {
      if(arrProcess[a].id === id) {
        itemTramite = arrProcess[a]
      }
    }
    return itemTramite
  }

  const getTramitesOt = () => {
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesOt',{
      method: 'POST',
      mode: 'cors'
    })
    .then( response => response.json())
    .then ( res => {
      console.log('tramitesOt',res.documents)
      setTramites(res.documents)
    })
  }

  const getBitacoras = () => {
    const data = {
      id_tramite: dataTramite.id_cotizacion
    }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getBitacoraByIdTramite',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then ( res => {
      setBitacoras(res.documents)
    })
  }

  const getTotalLiberado = (dataTramite) => {
    let totalAbonos = 0
    if(dataTramite.arrLiberaciones) {
      dataTramite.arrLiberaciones.map((t,e) => {
        totalAbonos += parseFloat(t.cantidad_liberada)
      })
    }
    return totalAbonos
  }

  const isPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    console.log('totalAbonos1: ', (parseFloat(cantidad) - totalAbonos));
    return ( (parseFloat(cantidad) - totalAbonos) <= 0) ? true : false;
  }

  const updateOT = () => {

    let _dataTramite = [], _tmp = dataTramite, canProcess = false

    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        let status = 2
        _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {
        if(isPayed(dataTramite) && _tmp.arrOT[0].arrProcess[a].status === 0 && dataTramite.metodo_pago === 'contado'){
          let status = 1;
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
        }else{
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        // canProcess = _tmp.arrOT[0].arrProcess[a - 1].status === 2 ? true : false
        if(isPayed(dataTramite) && _tmp.arrOT[0].arrProcess[a - 1].status === 2){
          let status = 1;
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status, })
        }else{
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }

    }

    const dataUpdate = {
      info: dataModificaInputsOT,
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    console.log('dataUpdate',dataUpdate);

    dataModificaInputsOT.map((form) => {
      if(form.tipo=='file' && typeof form.file !== 'undefined') {
        let formData = new FormData();
        formData.append('id', form.value)
        formData.append('files',form.file)

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveFileTramite',{
          method: 'POST',
          mode: 'cors',
          body: formData,
        }).then( response => response.json())
        .then( response => {

          dispatch(showAlert({
            show : true, 
            message : 'Documento / imagen subida con éxito.',
            type: 'success',
            duration: 3000,
          }))

        })

      }
    })

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( showAlert( {
        show : true, 
        message : 'Orden de trabajo terminada con éxito.',
        type: 'success',
        duration: 3000,
      } ) )
      socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
    })

    return false
  }

  const handleSubmitBitacora = (e) => {
    e.preventDefault();
  
    const dataBitacora = {
      area: getDepartamento(typeView),
      razon: razonBitacora,
      id_cotizacion: dataTramite.id_cotizacion,
      usuario: usuario.nombre,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(dataBitacora)
    })
    .then( response => response.json())
    .then( response => {
      getBitacoras();
    })
  }

  let dataFilter = [];
  if(tramites.length > 0) {
    dataFilter = tramites.filter( element  => element.id_cotizacion == dataTramite.id_cotizacion);
  }

  if(dataFilter.length === 0)
    return null

return(
    <Modal show={show} onHide={handleClose} size="xl" fullscreen={false}>
      <Modal.Header closeButton className="title">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        <Row>
          <Col xs={12}>
            <h5><i className="bi bi-person-bounding-box" style={{fontSize:'1.5rem'}}></i> {dataTramite.nombre}</h5>
            <h6 style={{color:'#707070'}}><i className="bi bi-file-earmark-text" style={{fontSize:'1.5rem'}}></i> {dataTramite.concepto2}</h6>
            <hr />
            {
              dataTramite && dataTramite?.arrOT[0]?.fecha_renovacion && (
                <h6><i class="bi bi-calendar-event"></i> Fecha de renovación: { moment(dataTramite.arrOT[0]?.fecha_renovacion).format('DD/MM/YYYY')}</h6>
              )
            }
          </Col>
          <Col xs={12} md={6}>
            <Card>
              <Card.Body>
                {
                  usuario.tipo_usuario === "1" && getItemByArrProcess(dataTramite,'orden_trabajo')?.status === 1 ?
                    <Button className="ws-btn-blue-2" onClick={ () => setEditarOT(!editarOT)}>{!editarOT ? 'Modificar orden de trabajo' : 'Cancelar modificación'}</Button> 
                  :
                    null
                }
                { (editarOT) && <Button className="ws-btn-blue-2 ms-2" onClick={ () => updateOT() }>Guardar cambios</Button> }
                <hr/>
                {
                  (!editarOT) ?
                    (dataFilter.length > 0) ?
                      (dataFilter[0].info) ? 
                        dataFilter[0].info.map((element,index) => (
                          <Form.Group key={`${index}`}>
                            <Form.Label><b>{element.nombre}</b></Form.Label>
                            <hr/>
                            {
                              element.tipo === 'file' ? <Button onClick={() => window.open(`https://wsoft0.s3.amazonaws.com/interbrokers/${element.value}`, '_blank') }><i className="bi bi-eye"></i>&nbsp;Haz clic para visualizar</Button> : <p>{element.value}</p>
                            }
                            {/* <Form.Control as="textarea" type={element.tipo} id={element.id} name={element.id} value={element.value} /> */}
                          </Form.Group>
                        ))
                      : null
                    : <p>No hay datos disponibles</p>
                  : 
                  <Form>
                    <Row className="ws-form-group-divider pb-3 pt-3">
                      {
                        dataFilter[0].info.map((t,e) => (
                          <Col key={`list-${e}`} xs={12} lg={12}>
                            <Form.Group className="mb-2">
                              <Form.Label className="ws-form-label">  
                                {t.nombre}
                              </Form.Label>
                              <Form.Control defaultValue={ t.tipo==='file' ? null : dataFilter[0].info[e].value }  name={t.id} type={t.tipo} multiple={(t.tipo==='file') ? true : false}
                              onChange={ (ev) => {
                                if(t.tipo==='file') {
                                  const id = uniqid()
                                  dataFilter[0].info[e].value = id
                                  dataFilter[0].info[e].file = ev.target.files[0]
                                } else {
                                  dataFilter[0].info[e].value = ev.target.value
                                }

                                setModificaOT(dataFilter[0].info)
                              } }

                              />
                            </Form.Group>
                          </Col>
                        ))
                      }
                      <hr />
                    </Row>
                  </Form>
                }
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <div className="ws-box-container mb-2">
              <h6 style={{ textAlign: 'center', fontWeight: 800, backgroundColor: '#f3f3f3', padding: 5, }}>Historial de pagos ({dataTramite.arrCobranza.length})</h6>
              <hr />
              {
                dataTramite.arrCobranza.length > 0 &&
                <>
                  <Row>
                    <Col>
                      <b>Forma de pago</b>
                    </Col>
                    <Col>
                      <b>Cantidad</b>
                    </Col>
                    <Col>
                      <b>Archivos</b>
                    </Col>
                  </Row>
                  { dataTramite.arrCobranza && dataTramite.arrCobranza.map((t,e) => (
                    <Row key={e}>
                      <Col>
                        <p style={{ margin: 0, }}>{t.forma_pago}</p>
                      </Col>
                      <Col>
                        <p style={{ margin: 0, }}>${number_format(t.cantidadRecibida, 2)}</p>
                      </Col>
                      <Col>
                      {
                        t.files && t.files.length > 0 &&
                        <ul className="navbar-nav ms-auto ws-dropdown-list">
                          <li className="nav-item dropdown position-static">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                              <i className="bi bi-three-dots-vertical"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                              {
                                t.files.map((t0,e0) => (
                                  <a key={e0} 
                                  onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} 
                                  className="dropdown-item"
                                  style={{cursor: 'pointer'}}
                                  >
                                    <i className="bi bi-link"></i> {t0.file}
                                  </a>
                                ))
                              }
                            </div>
                          </li>
                        </ul>
                      }
                      </Col>
                    </Row>
                    ))
                  }
                </>
              }
            </div>
            <div className="ws-box-container mb-2">
              <h6>Historial transferencias de fondos ({dataTramite.arrLiberaciones.length})</h6>
              <hr />
              {
                dataTramite.arrLiberaciones.length > 0 &&
                <>
                  <Row>
                    <Col>
                      <b>Referencia</b>
                    </Col>
                    <Col>
                      <b>Cantidad liberada</b>
                    </Col>
                    <Col>
                      <b>Archivos</b>
                    </Col>
                  </Row>
                  { dataTramite.arrLiberaciones && dataTramite.arrLiberaciones.map((t,e) => (
                    <Row key={e}>
                      <Col>
                        <p style={{ margin: 0, }}>{t.referencia}</p>
                      </Col>
                      <Col>
                        <p style={{ margin: 0, }}>${number_format(t.cantidad_liberada, 2)}</p>
                      </Col>
                      <Col>
                      {
                        t.files && t.files.length > 0 &&
                        <ul className="navbar-nav ms-auto ws-dropdown-list">
                          <li className="nav-item dropdown position-static">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                              <i className="bi bi-three-dots-vertical"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                              {
                                t.files.map((t0,e0) => (
                                  <a key={e0} 
                                  onClick={() => {
                                    window.open(t0.url, '_blank')
                                  }} 
                                  className="dropdown-item"
                                  style={{cursor: 'pointer'}}
                                  >
                                    <i className="bi bi-link"></i> {t0.file}
                                  </a>
                                ))
                              }
                            </div>
                          </li>
                        </ul>
                      }
                      </Col>
                    </Row>
                    ))
                  }
                </>
              }
            </div>
            <div className="ws-box-container mb-2">
              <h6>Bitácora</h6>
              <Button className="ws-btn-blue-2" onClick={() => setViewBitacora(!viewBitacora)}>Agregar</Button>
              {
                (viewBitacora) ?
                <Form onSubmit={handleSubmitBitacora}>  
                  <Form.Group className="mt-2 mb-2">  
                    <Form.Label>Escribe una anotación</Form.Label>
                    <Form.Control required value={razonBitacora} as="textarea" rows={4} onChange={
                      (e) => {
                        setRazonBitacora(e.target.value);
                      }
                    } placeholder="Escribe una anotación para registrar en la bitácora" />
                  </Form.Group>
                  <Form.Group>
                    <Button type="submit">Guardar</Button>
                  </Form.Group>
                </Form>
                : null
              }
              <hr/>
            {
              (bitacoras.length > 0) ?
                bitacoras.map((bitacora,index) =>(
                  <div key={index}>
                    <p style={{marginBottom:'7px'}}><b>Departamento: </b> <Badge bg="primary" style={{fontSize:'.95rem'}}>{bitacora.area}</Badge> </p>
                    
                    <p style={{marginBottom:'7px',color:'#404040'}}><span style={{fontSize:'.9rem'}}><i className="bi bi-calendar"></i> { moment(bitacora.created_at).format('DD/MM/YYYY HH:mm') }</span> <span> - <i className="bi bi-person-fill"></i> Creado por: {bitacora.usuario}</span></p>
                    <p style={{backgroundColor:'#ededed',padding:'5px',borderRadius:'5px',border:'1px solid #dfdfdf'}}><b>Razón:</b> <br />{bitacora.razon}</p>
                    <hr/>
                  </div>
                ))
              : <p>Aún no hay datos en la bitácora</p>
            }
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="text-center">
            <Button className="ws-btn-blue-2" onClick={() => {
              dispatch( setStateGlobal({ showModalModificarCostoTramite: true, dataTramite }))
            }}>Modificar costo del trámite</Button>
          </Col>
          <Col className="text-center">
            <Button className="ws-btn-blue-2" onClick={() => {
              dispatch( setStateGlobal({ showModalRegresarTramite: true, dataTramite }))
            }}>Regresar trámite</Button>
          </Col>
          <Col className="text-center">
            <Button className="ws-btn-blue-2" onClick={() => {
              dispatch( setStateGlobal({ showModalFinalizarProceso: true, dataTramite }))
            }}>Finalizar proceso</Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

const ModalRegresarTramite = ({ show, handleClose, typeView }) => {
  const {usuario} = useContext(AuthContext);
  
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalRegresarTramite,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  //Referencias
  const refSelectArea = useRef(null);
  const refTextRazon = useRef(null);
  const [cantidadRecibida, setCantidadRecibida] = useState('');
  const [btnIsLoading,setBtnIsLoading] = useState(false);
  const [dataComponent,setDataComponent] = useState({
    alert: {  
      status: false,
      messageText: ''
    }
  })

  let cantidadNumber = 0

  if(dataTramite.cantidad) {
    if(typeof dataTramite.cantidad == 'string'){
      cantidadNumber = dataTramite.cantidad.replace('$', '')
      cantidadNumber = cantidadNumber.replace(',', '')
      // cantidadNumber = cantidadNumber.parseFloat()
    }else{
      cantidadNumber = dataTramite.cantidad;
    }
  }

  const handleSubmitRegresarTramite = () => {
    /*
    if(refSelectArea.current.value===''){
      refSelectArea.current.focus();
      setDataComponent({...dataComponent,
        alert: { ...alert, status: true, messageText: 'Selecciona una área' }
      })
      return false;
    }
    */
    if(refTextRazon.current.value===''){
      refTextRazon.current.focus();
      setDataComponent({...dataComponent,
        alert: {...alert, status: true, messageText: 'Ingresa una razón'}
      })
      return false;
    }
    setDataComponent({
      ...dataComponent,
      alert: {...alert, status: false, messageText: '' }
    })



    let _dataTramite = [], _tmp = dataTramite
    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 1,
        })
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        _dataTramite.push({
          ..._tmp.arrOT[0].arrProcess[a],
          status: 0,
        })
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }
    }

    const dataUpdate = {
      arrProcess: _dataTramite,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    setBtnIsLoading(true);

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
     method: 'POST',
     mode: 'cors',
     body: JSON.stringify(dataUpdate),
    })
    .then( response => response.json())
    .then( response => {

      const data = {
        area : getDepartamento(typeView),
        razon : refTextRazon.current.value,
        id_cotizacion: dataTramite.id_cotizacion,
        usuario: usuario.nombre
      }
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveBitacora',{
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data)
      })
      .then( response => response.json())
      .then( res => {
        window.location.href = "";
      })
    })
  }

  return (
    <Modal show={showModalRegresarTramite} onHide={ () => {
      dispatch( setStateGlobal({ showModalRegresarTramite: false, }) )
      setDataComponent({
        ...dataComponent,
        alert: {...alert, status: false, messageText: '' }
      })
    }} size="md" fullscreen={false}>
      <Modal.Header closeButton className="title">
        <Modal.Title>Regresar trámite</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={12}>
              <Form onSubmit={(e)=>e.preventDefault()}>
                {
                  /*
                    <Form.Group className="mb-3">
                      <Form.Label>¿A qué área va?</Form.Label>
                      <Form.Select ref={refSelectArea}>
                        <option value="">Selecciona una opción</option>
                        <option value="orden_trabajo">Atención a clientes - Orden de trabajo</option>
                        <option value="tramites">Trámites</option>
                        <option value="caja">Caja</option>
                      </Form.Select>
                    </Form.Group>
                  */
                }
                <Form.Group className="mb-3">
                  <Form.Label>Escribe la Razón</Form.Label>
                  <Form.Control rows={5} ref={refTextRazon} as="textarea" placeholder="Escribe la razón"/>
                </Form.Group>
                { (dataComponent.alert.status) && <Alert variant="danger">{dataComponent.alert.messageText}</Alert> }
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button 
        disabled={btnIsLoading}
        onClick={() => { handleSubmitRegresarTramite() }} 
        className="btn btn-primary ws-btn-blue-2"
        >
          {
            btnIsLoading ?
              <>Guardando... <Spinner animation="border" size="sm" /></>
            :
              'Continuar'
          }
        </button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalHistorial = ({ show, handleClose }) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  let { 
    showModalHistorial,
    newCotizacion,
    dataTramite,
  } = stateGlobal;

  if(!dataTramite.arrOT)
    return null

  let newSortData = [];
  if(dataTramite.arrOT[0].arrHistory){
    newSortData = dataTramite.arrOT[0].arrHistory.slice().sort((a, b) => new Date(b.fecha.replace(/-/g, "/")) - new Date(a.fecha.replace(/-/g, "/")));
  }

  return (
    <Modal show={showModalHistorial} onHide={ () => {
      dispatch( setStateGlobal({ showModalHistorial: false, }) )
      
    }} size="md" fullscreen={false}>
      <Modal.Header closeButton className="title">
        <Modal.Title>Historial de actividades</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={12}>
              { newSortData.map((t,e) => (

                <Row key={e}>
                  <Col>
                    <b>{t.usuario_nombre}</b>
                    <p>Motivo: {t.motivo}</p>
                    <p>Fecha: { moment(t.fecha).format('DD/MM/YYYY HH:mm') }</p>
                  </Col>
                  <hr />
                </Row>

              )) }
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  )
}

const ModalFilter = ({ show, handleClose }) => {

  const [state, setState] = useState({
    section: 1,
    search_input: '',
    dataRamos: [],
    dataCompanias: [],
    dataAgentes: [],
  })

  const handleSetSection = (section) => setState({ ...state, section: section });

  return (
    <Modal show={show} onHide={handleClose} size="lg" fullscreen={false}>
      <Modal.Header closeButton className="title">
        <Modal.Title>FILTRAR POR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col xs={12}>
              <div className="ws-tab-container pb-3 mb-3">

                <ul className="nav nav-pills mb-3">
                  <li className="nav-item">
                    <a className={`nav-link ${(state.section === 1) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(1)}>Ramos</a>
                  </li>
                  <li className="nav-item ms-2">
                    <a className={`nav-link ${(state.section === 2) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(2)}>Compañias</a>
                  </li>
                  <li className="nav-item ms-2">
                    <a className={`nav-link ${(state.section === 3) && 'active'}`} aria-current="page" href="#" onClick={() => handleSetSection(3)}>Agentes</a>
                  </li>
                </ul>

                <form action="" className="d-flex flex-column align-items-end flex-md-row mt-3 gap-2 mb-3">
                  <div className="container-fluid p-0">
                    <div className="row">
                      <div className="col-12 col-md-9">
                        <div className="form-group group-search mb-1">
                          <i className="bi bi-search pe-2"></i>
                          <input
                            type="search"
                            className="form-control ws-input-search"
                            placeholder="Filtrar por ramo, compañia o agente"
                            value={state.search_input}
                            onChange={(e) => setState({ ...state, search_input: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="form-group mb-1">
                          <button className="btn btn-primary ws-btn-blue-2"><i className="bi bi-search pe-2"></i> Buscar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <button className="btn btn-light mb-3">Buscar pagos cotejados</button>

                {
                  (state.section === 1) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LOS RAMOS QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Ramo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>Autos</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>GMM</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

                {
                  (state.section === 2) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LAS COMPAÑÍAS QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Compañia</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>SEGUROS EL POTOSI</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>QUÁLITAS COMPAÑIAS DE SEGUROS</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

                {
                  (state.section === 3) && (
                    <React.Fragment>
                      <div className="bg-light border rounded-1 p-2">
                        <p className='mb-0'> <i className='bi bi-info-circle-fill' style={{ color: '#777' }}></i> SELECCIONA LOS AGENTES QUE DESEAS FILTRAR PARA OBTENER RESULTADOS.</p>
                      </div>
                      <Table hover className="mt-3 mb-3">
                        <thead>
                          <tr>
                            <th width="10%">
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </th>
                            <th width="90%">Agente</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-1" />
                              </div>
                            </td>
                            <td>(60004) TONO RAMIRO</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="data-2" />
                              </div>
                            </td>
                            <td>(561424) JOSE ANTONIO RAMIRO</td>
                          </tr>
                        </tbody>
                      </Table>
                    </React.Fragment>
                  )
                }

              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary ws-btn-blue-2"><i className="bi bi-search pe-2"></i> Buscar</button>
      </Modal.Footer>
    </Modal>
  )
}

const ModalConfirmacion = ({show, message, handleDelete, handleCancel,isLoading,textConfirm,textCancel,children=''}) => {

  const [btnLoading,setBtnLoading] = useState(false);

  useEffect(()=> {
    setBtnLoading(isLoading);
  },[isLoading])

  return(
    <Modal
      show={show}
      onHide={handleCancel}
      size="sm"
      fullscreen={false}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton={btnLoading ? false : true} className="title">
        <Modal.Title>Confirmar</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ws-modal-body">
        {message}
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button className="ws-button-light" onClick={handleCancel} disabled={btnLoading} >{textCancel}</Button>
        <Button variant="danger" onClick={handleDelete} disabled={btnLoading} >
          {
            btnLoading ?
            <> {textConfirm} <Spinner animation="border" size="sm" /> </>
            :
            textConfirm
          }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export {
  ModalNuevaCotizacion,
  ModalFilter,
  ModalConfirmacion,
  ModalRealizarCobro,
  ModalAutorizarTramite,
  ModalModificarCostoTramite,
  ModalFinalizarProceso,
  ModalRegresarTramite,
  ModalTwoColumnsOt,
  ModalTwoColumnsOtProcesos,
  ModalNotificarCliente,
  ModalHistorial,
}
